/** @type {Map<string, object>} */
const cache = new Map();

/** @type {Map<string, Promise<object|null>>} */
const inflight = new Map();

/**
 * 按 slug 去重 Gamma 请求：内存缓存 + in-flight Promise 合并。
 * @param {string} slug
 * @param {(slug: string) => Promise<object|null>} fetchFn
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<object|null>}
 */
export async function fetchGammaEventCached(slug, fetchFn, options = {}) {
  const s = String(slug || '').trim();
  if (!s) return null;

  const forceRefresh = Boolean(options.forceRefresh);
  if (!forceRefresh && cache.has(s)) {
    return cache.get(s);
  }

  const inflightKey = forceRefresh ? `${s}|fresh` : s;
  const pending = inflight.get(inflightKey);
  if (pending) {
    return pending;
  }

  const promise = fetchFn(s)
    .then((event) => {
      if (event != null && typeof event === 'object') {
        cache.set(s, event);
        return event;
      }
      // 空结果不永久占坑；已有有效缓存保留
      return cache.has(s) ? cache.get(s) : null;
    })
    .catch((err) => {
      console.warn(`[gamma] cached fetch failed slug=${s}`, err);
      return cache.has(s) ? cache.get(s) : null;
    })
    .finally(() => {
      inflight.delete(inflightKey);
    });

  inflight.set(inflightKey, promise);
  return promise;
}

/** @param {string} slug */
export function getCachedGammaEvent(slug) {
  const s = String(slug || '').trim();
  if (!s || !cache.has(s)) return undefined;
  return cache.get(s);
}

export function clearGammaEventCache() {
  cache.clear();
  inflight.clear();
}
